import {SeniorityLevel} from '@/profile-creation-wizard/components/for-completion/domain/types';

export function toSeniorityLevel(seniorityResource: any): SeniorityLevel | null {
    return SeniorityLevel[seniorityResource.seniority] ? SeniorityLevel[seniorityResource.seniority] : null;
}
